export enum CumulativeBoosterState
{
  Ready = "ready",
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
}
